/* Printhia delivery estimate + options modal.
   Reads the JSON island rendered by snippets/delivery-estimate.liquid.
   Date logic verified in date-test.mjs (working days + SK holidays + 13:00 cutoff, Europe/Bratislava). */
(function () {
  'use strict';

  var MONTHS = ['januára','februára','marca','apríla','mája','júna','júla','augusta','septembra','októbra','novembra','decembra'];

  function pad(n){ return String(n).padStart(2,'0'); }
  function ymd(d){ return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate()); }
  function addDays(d,n){ var x=new Date(d); x.setDate(x.getDate()+n); return x; }

  function easter(year){
    var a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,
        f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,
        i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),
        month=Math.floor((h+l-7*m+114)/31),day=((h+l-7*m+114)%31)+1;
    return new Date(year,month-1,day);
  }
  function skHolidays(year){
    var fixed=['1-1','1-6','5-1','5-8','7-5','8-29','9-1','9-15','11-1','11-17','12-24','12-25','12-26'];
    var set={};
    fixed.forEach(function(s){ var p=s.split('-'); set[year+'-'+pad(+p[0])+'-'+pad(+p[1])]=1; });
    var es=easter(year);
    set[ymd(addDays(es,-2))]=1; // Veľký piatok
    set[ymd(addDays(es,1))]=1;  // Veľkonočný pondelok
    return set;
  }
  function holidaysFor(years){ var s={}; years.forEach(function(y){ var h=skHolidays(y); for(var k in h) s[k]=1; }); return s; }
  function isWorking(d,hol){ var g=d.getDay(); return g!==0 && g!==6 && !hol[ymd(d)]; }

  function deliveryDate(now, leadDays, cutoffHour, hol){
    var anchor=new Date(now.getFullYear(),now.getMonth(),now.getDate());
    var beforeCutoff = now.getHours() < cutoffHour;
    if(!(isWorking(anchor,hol) && beforeCutoff)){
      anchor=addDays(anchor,1);
      while(!isWorking(anchor,hol)) anchor=addDays(anchor,1);
    }
    var cur=anchor, added=0;
    while(added<leadDays){ cur=addDays(cur,1); if(isWorking(cur,hol)) added++; }
    return cur;
  }

  // Current date/time in Europe/Bratislava regardless of the visitor's timezone.
  function bratislavaNow(){
    try{
      var parts=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Bratislava',
        year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hour12:false}).formatToParts(new Date());
      var o={}; parts.forEach(function(p){ o[p.type]=p.value; });
      var hour = o.hour==='24' ? 0 : parseInt(o.hour,10);
      return new Date(parseInt(o.year,10), parseInt(o.month,10)-1, parseInt(o.day,10), hour);
    }catch(e){ return new Date(); }
  }

  function fmtPrice(n){
    return (Math.round(n*100)/100).toFixed(2).replace('.', ',') + ' €';
  }
  function tierPrice(rate, kg){
    var t=rate.tiers, chosen=t[t.length-1];
    for(var i=0;i<t.length;i++){ if(t[i].max==null || kg<=t[i].max){ chosen=t[i]; break; } }
    return chosen.price;
  }

  // Delivery window in working days, scaled by variant weight (grams).
  function weightTier(g){
    if(g < 200) return [8,10];
    if(g < 400) return [9,12];
    if(g < 700) return [10,13];
    return [12,15];
  }
  // "8. - 13. júla" (same month) or "29. júna - 6. júla" (across months). ASCII hyphen.
  function fmtRange(d1,d2){
    if(d1.getMonth()===d2.getMonth() && d1.getFullYear()===d2.getFullYear()){
      return d1.getDate()+'. - '+d2.getDate()+'. '+MONTHS[d2.getMonth()];
    }
    return d1.getDate()+'. '+MONTHS[d1.getMonth()]+' - '+d2.getDate()+'. '+MONTHS[d2.getMonth()];
  }

  function init(root){
    var cfgEl=root.querySelector('script[data-de-config]');
    if(!cfgEl) return;
    var data;
    try{ data=JSON.parse(cfgEl.textContent); }catch(e){ return; }
    var cfg=data.config||{}, variants=data.variants||{};
    var rates=[]; var rEl=root.querySelector('script[data-de-rates]');
    if(rEl){ try{ rates=JSON.parse(rEl.textContent)||[]; }catch(e){ rates=[]; } }
    var hol=holidaysFor([new Date().getFullYear(), new Date().getFullYear()+1]);

    // ---- delivery date (scales with the selected variant's weight) ----
    var dateEl=root.querySelector('[data-de-date]');
    function renderDate(v){
      if(!dateEl) return;
      var now=bratislavaNow();
      // Products with an explicit dispatch override (e.g. express 24h) keep a
      // single date; everyone else gets the weight-based working-day range.
      if(cfg.leadOverride && cfg.leadOverride>0){
        var d=deliveryDate(now, cfg.leadOverride, cfg.cutoffHour||13, hol);
        dateEl.textContent=d.getDate()+'. '+MONTHS[d.getMonth()];
        return;
      }
      var grams=(v&&v.grams)||0;
      var t=weightTier(grams);
      var d1=deliveryDate(now, t[0], cfg.cutoffHour||13, hol);
      var d2=deliveryDate(now, t[1], cfg.cutoffHour||13, hol);
      dateEl.textContent=fmtRange(d1,d2);
    }

    // ---- per-variant pieces ----
    var methodsEl=root.querySelector('[data-de-methods]');
    var availEl=root.querySelector('[data-de-avail]');

    function currentVariantId(){
      var form=document.querySelector('form[action*="/cart/add"]');
      var input=form && form.querySelector('[name="id"]');
      if(input && variants[input.value]) return input.value;
      return data.currentId;
    }
    function renderAvailability(v){
      if(!availEl||!v) return;
      var item = availEl.closest ? availEl.closest('[data-de-availitem]') : null;
      var text='', state='made';
      if(v.tracked){
        if(v.qty>5){ text='SKLADOM (>5 ks)'; state='in'; }
        else if(v.qty>0){ text='SKLADOM ('+v.qty+' ks)'; state='in'; }
        else if(v.policy==='continue'){ text=''; state='made'; }
        else { text='Vypredané'; state='out'; }
      }
      // Made-to-order: hide the whole "Dostupnosť" item (label + dot). Inline
      // style beats the theme's .de-item{display:flex} rule (which overrode the
      // hidden attribute).
      if(state==='made'){ availEl.textContent=''; if(item) item.style.display='none'; }
      else { availEl.textContent=text; if(item) item.style.display=''; }
      availEl.setAttribute('data-state',state);
    }
    function renderMethods(v){
      if(!methodsEl||!v) return;
      var kg=(v.grams||0)/1000;
      methodsEl.innerHTML='';
      var items = rates.map(function(r){ return { r:r, price: tierPrice(r, kg) }; });
      items.sort(function(a,b){ return a.price - b.price; }); // cheapest first
      items.forEach(function(it){
        var r=it.r;
        var li=document.createElement('li');
        var badge=document.createElement('span');
        badge.className='de-carrier'; badge.setAttribute('data-c', r.carrier);
        badge.textContent={posta:'POŠTA',gls:'GLS',packeta:'PACKETA',dpd:'DPD'}[r.carrier]||r.carrier.toUpperCase();
        var name=document.createElement('span');
        name.className='de-method-name'; name.textContent=r.label;
        var price=document.createElement('span');
        price.className='de-method-price';
        price.textContent = fmtPrice(it.price);
        li.appendChild(badge); li.appendChild(name); li.appendChild(price);
        methodsEl.appendChild(li);
      });
    }
    function update(){
      var v=variants[currentVariantId()]||variants[data.currentId];
      renderAvailability(v); renderMethods(v); renderDate(v);
    }
    update();

    // react to variant switches (Refresh/Dawn dispatch change on the picker + update [name=id])
    document.addEventListener('change', function(e){
      if(e.target.closest && e.target.closest('variant-selects,variant-radios,.product-form__input,form[action*="/cart/add"]')){
        setTimeout(update,60);
      }
    });

    // ---- dialog open/close ----
    var dlg=root.querySelector('[data-de-dialog]');
    var openBtn=root.querySelector('[data-de-open]');
    if(dlg && openBtn){
      openBtn.addEventListener('click', function(){ if(dlg.showModal) dlg.showModal(); else dlg.setAttribute('open',''); });
      dlg.addEventListener('click', function(e){ if(e.target===dlg){ dlg.close(); } }); // backdrop click
      var x=dlg.querySelector('[data-de-close]');
      if(x) x.addEventListener('click', function(){ dlg.close(); });
    }
  }

  function boot(){
    document.querySelectorAll('[data-delivery-estimate]').forEach(init);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
